import { useId } from 'react'

import { FormControlLayoutProps } from './FormControlLayout.js'
import { FormControlProps } from './types.js'

export const extractLayoutProps = <T extends FormControlProps>({
  name,
  label,
  secondaryLabel,
  tertiaryLabel,
  helperText,
  error,
  invalid,
  hidden,
  size,
  ...rest
}: T) => {
  const layoutProps: Omit<FormControlLayoutProps, 'children'> = {
    name,
    label,
    secondaryLabel,
    tertiaryLabel,
    helperText,
    error,
    invalid,
    hidden,
    size,
  }

  const inputProps = {
    id: name,
    name,
    invalid,
    size,
    ...rest,
  }

  return { layoutProps, inputProps }
}

export type FormControlIds = { labelId: string; errorId: string }

export const useFormControlIds = (): FormControlIds => {
  const id = useId()

  return { labelId: `${id}label`, errorId: `${id}error` }
}

export const getFormControlErrorAriaProps = ({
  invalid,
  error,
  errorId,
}: Pick<FormControlProps, 'invalid' | 'error'> &
  Pick<FormControlIds, 'errorId'>) =>
  invalid && error
    ? {
        'aria-invalid': true as const,
        'aria-describedby': errorId,
      }
    : {}
